document.addEventListener('DOMContentLoaded', function () {
  var observer = new IntersectionObserver(
    function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.1 }
  );

  document
    .querySelectorAll(
      '.promise-item, .split-text, .split-image, .visual-demo-container, .ts-card, .faq-item, .offer-card'
    )
    .forEach(function (el) {
      el.classList.add('reveal-on-scroll');
      observer.observe(el);
    });

  var videos = document.querySelectorAll('video');
  if (videos.length > 0) {
    var videoObserver = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.preload = 'metadata';
            obs.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '200px' }
    );
    videos.forEach(function (v) {
      videoObserver.observe(v);
    });
  }
});
